import React from "react";

export const Skeleton: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`animate-pulse bg-stone-100/80 rounded-sm ${className}`} />
);

export const PropertyCardSkeleton: React.FC = () => {
  return (
    <div className="border border-stone-100/50 rounded-sm overflow-hidden flex flex-col h-full bg-white shadow-sm">
      {/* Image Skeleton */}
      <div className="relative aspect-[4/3] w-full bg-stone-100 overflow-hidden">
        <Skeleton className="absolute inset-0" />
      </div>

      {/* Content Skeleton */}
      <div className="p-6 md:p-8 flex flex-col flex-1 gap-4">
        {/* Title */}
        <div className="space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>

        {/* Location & Ref */}
        <div className="flex items-center gap-3 mt-2">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-4 w-1/4" />
        </div>

        <div className="flex-1" />

        {/* Price & Features */}
        <div className="pt-6 mt-6 border-t border-stone-100 flex items-end justify-between">
          <Skeleton className="h-8 w-1/3" />
          <div className="flex gap-4">
            <Skeleton className="h-5 w-8" />
            <Skeleton className="h-5 w-8" />
          </div>
        </div>
      </div>
    </div>
  );
};
